import { Dialog, DialogTitle, makeStyles } from "@material-ui/core";
import { Close, Tune } from "@material-ui/icons";
import { ReactNode } from "react";

interface FilterDialogProps {
  isOpen: boolean;
  children: ReactNode;
  setIsOpen: (open: boolean) => void;
  title: string;
  useCustomStyle?: boolean;
}

const FilterDialog = (props: FilterDialogProps) => {
  const classes = useStyles();

  return (
    <Dialog onClose={() => props.setIsOpen(false)} open={props.isOpen}>
      <div className={classes.filterTitle}>
        <DialogTitle style={{ paddingBottom: "0" }}>Filters</DialogTitle>
        <div
          onClick={() => {
            props.setIsOpen(false);
          }}
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          <Close />
        </div>
      </div>
      {props.useCustomStyle ? props.children : <div className={classes.dialogFilters}>{props.children}</div>}
    </Dialog>
  );
};
interface FilterDialogButtonProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  text?: string;
}

export const FilterDialogButton = (props: FilterDialogButtonProps) => {
  const classes = useStyles();
  return (
    <div className={classes.filters}>
      <div
        onClick={() => {
          props.setIsOpen(!props.isOpen);
        }}
        children={<Tune />}
        style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}
      />
      <span>{props.text ? props.text : "Filters"}</span>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  filterTitle: {
    minWidth: "250px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "15px",
  },
  filters: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    columnGap: "5px",
  },
  dialogFilters: {
    display: "flex",
    flexDirection: "column",
    padding: "30px 15px",
    rowGap: "10px",
    "& div": {
      margin: "0 !important",
      minWidth: "0",
    },
    "& .date-picker": {
      width: "100% !important",
    },
  },
}),
{ index: 1 },
);

export default FilterDialog;
